import React, { useState } from "react";
import { MDBInput } from "mdb-react-ui-kit";
import Select from "react-select";
import NotificationAlert from "react-notification-alert";
import {
  Row,
  Col,
  Input,
  FormGroup,
  UncontrolledTooltip,
  Button,
} from "reactstrap";
import axios from 'axios';
 
var initialvalues = {
  mobile:"",
  senderId:"",
  message:""
}
const InstantFields = (props) => {
 
  const [singleSelect, setsingleSelect] = useState(null);
  const [instantDrpdwn, setInstaDrpdwn] = useState(props.instDrpdwn);
  const [instantFields, setInstantFields] = useState(initialvalues);
  const [count, setCount] = React.useState(0);
  const notificationAlertRef = React.useRef(null);
  
  const submitFields = ()=>{
    if(instantFields.senderId!="" && instantFields.message!=""&& instantFields.mobile!=""){
    let payload={
      "mobile_no":instantFields.mobile.split(","),
      "sender_id":instantFields.senderId,
      "template_id" : singleSelect.value,
      "callflow_name":singleSelect.label,
      "message":instantFields.message
  
    }
  
     axios.post(props.api, payload).then((response) => {
      let options = {};
      options = {
        place: "tr",
        message: "Saved Successfully",
        type: "success",

        autoDismiss: 2,
      };
      setInstantFields(initialvalues);
      

     notificationAlertRef.current.notificationAlert(options);
   
     }).catch(err=>console.log("err==>",err));
    }else{
      let options = {};
      options = {
        place: "tr",
        message: "Please fill all fields",
        type: "warning",

        autoDismiss: 2,
      };
      

     notificationAlertRef.current.notificationAlert(options);
    }
  }
  return (
    <div>
      <Row className="mb-4 ">
      <NotificationAlert ref={notificationAlertRef} />
        <Col md="4" sm="12" className="mt-4 ">
          <MDBInput label="Mobile No" type="text" value={instantFields.mobile} name="mobileno" placeholder="111,222"  onChange={(e)=>{setInstantFields({
           ...instantFields,mobile: e.target.value
          })}} />
        </Col>
        <Col md="4" sm="12" className="mt-4">
          <MDBInput label="Sender Id" type="number" value={instantFields.senderId} name="senderid" className="no-spinner"  onChange={(e)=>setInstantFields({
           ...instantFields,senderId: e.target.value
          })} />
        </Col>
        {
          props.channel !=="whatsapp"&& <Col md="4" sm="12">
          <p className="category">Select {props.name}</p>
          <Select
            className="react-select info"
            classNamePrefix="react-select"
            name="singleSelect"
            value={instantDrpdwn.value}
            onChange={(value) => setsingleSelect(value)}
            options={instantDrpdwn}
            placeholder="Select"
          />
        </Col>
        }
       
      
        <Col md="4" sm="12">
          <label>Message </label>
          <FormGroup>
            <Input type="textarea" placeholder="Enter Message" 
            maxLength={160}
            value={instantFields.message.substring(0, 160)} onChange={e => {setInstantFields({
           ...instantFields,message: e.target.value
          });setCount(e.target.value.length)}} />
            <label style={{float:"right"}}>{count} / 160</label>
          </FormGroup>
        </Col>
        <Col md="3" sm="3">
          <Button
            color="primary "
            className="mt-4 btn btn-icon animation-on-hover"
            id="tooltipsubmit"
            type="button"
            onClick={()=>submitFields()}
          >
            <i className="tim-icons icon-double-right" />
          </Button>
          <UncontrolledTooltip delay={0} placement="top" target="tooltipsubmit">
            Submit
          </UncontrolledTooltip>
        </Col>
      </Row>
    </div>
  );
};

export default InstantFields;
